import {CUSTOM_FORM_KEY_PREFIX} from '../constants';
import type {ICustomFormItem} from '../types';

export const getCustomFormBaseFieldName = (item: ICustomFormItem) =>
	`${CUSTOM_FORM_KEY_PREFIX}${item.label.key}`;
